import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { COLORS } from "../config/theme/baseTheme";
import { deliveryProofSectionStyles, geocodedAddressStyles, tabularSectionCratesStyles, tagStyles, useSideModalCloseOpenStyles, detailsContentStyle, timelineBaseStyles, timelineDotStyles, timelineConnectorStyles, timelineContentStyles, timelineItemStyles, paymentContainerStyles } from "SharedComponent/styles/sharedStyles";
import { useColorStyles } from "SharedComponent/styles/Colores.styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    titleContainer: {
      "& .headingContainer": {
        flexDirection: "column",
        "& .titleHeading": {
          fontSize: 18,
          fontWeight: 500,
          "& .content": {
            fontWeight: 600,
          },
        },
        "& .titleContent": {
          fontSize: 12,
          fontWeight: 600,
          lineHeight: "15px",
          "&.link": {
            cursor: "pointer",
          },
        },
      },
      "& .tagContainer": {
        marginLeft: theme.spacing(1),
        "& .tag": {
          ...tagStyles(theme).base,
          ...useColorStyles(theme),
        },
      },
      "& .editIcon": {
        paddingLeft: theme.spacing(1),
        "& .icon": {
          cursor: "pointer",
          verticalAlign: "middle",
          fill: "none",
        },
        "& .refreshText": {
          color: COLORS.MYSTIC_GREY,
          fontSize: 12,
        },
        "& .refresh-block": {
          cursor: "default !important",
        },
      },
    },
    iconDownlod: {
      display: "flex",
      justifyContent: "flex-end",
      marginBottom: 12,
      marginTop: "-24px",
      "& .icon": {
        fill: "none",
        width: "auto",
        height: "auto",
      },
    },
    contentContainer: {
      flexDirection: "column",
      flexWrap: "nowrap",
      "& .tabValues": {
        padding: "8px 0px 0px 0px",
      },
      "& .geocodedAddress": {
        paddingBottom: theme.spacing(2),
        ...geocodedAddressStyles(theme),
      },
      "& .detailsHeader": {
        padding: "12px 20px",
        marginTop: "18px",
        borderRadius: "4px",
        background: "#FFFFFF",
        boxShadow: "0px 4px 48px rgba(0, 0, 0, 0.08)",
        backdropFilter: "blur(24px)",
        "& .vehicleType": {
          display: "flex",
          alignItems: "center",
          fontSize: "10px",
          fontWeight: 700,
          marginRight: "4px",
          textTransform: "capitalize",
        },
      },
      "& .deliveryDetails": {
        marginTop: "12px",
        "& .delivery": {
          fontSize: "14px",
          fontWeight: 400,
        },
        "& .deliveryTimeDetails": {
          fontSize: "14px",
          fontWeight: 700,
          lineHeight: "16px",
        },
        "& .location": {
          width: "16px",
          height: "16px",
          marginRight: "8px",
        },
      },
      "& .detailsHeaderItem": {
        paddingBottom: theme.spacing(1),
        paddingTop: "16px",
        "& .headerItemContainer": {
          alignItems: "center",
          flexWrap: "nowrap",
        },
        "& .contactItemContainer": {
          alignItems: "center",
          flexWrap: "nowrap",
        },
        "& .contactMobile": {
          marginRight: theme.spacing(5),
        },
        "& .logo": {
          width: 24,
          height: 24,
        },
        "& .contact": {
          "& a": {
            lineHeight: "17px",
            fontSize: 14,
            fontWeight: 600,
            textDecoration: "none",
            color: theme.palette.text.primary,
          },
          paddingLeft: theme.spacing(1),
          "&.mobile": {
            paddingLeft: theme.spacing(0.25),
          },
        },
      },
      ...detailsContentStyle(theme),
      "& .sellerDetails": {
        paddingTop: theme.spacing(1.75),
        "& .detailsHeader": {
          backgroundColor: theme.palette.secondary.main,
        },
      },
      "& .driverDetails": {
        paddingBottom: theme.spacing(1),
      },
       ...deliveryProofSectionStyles(theme),
      "& .consignmentHistory": {
        paddingBottom: theme.spacing(1),
      },
      "& .tabularSection": {
        paddingBottom: theme.spacing(1),
        "&:last-child": {
          paddingBottom: 0,
        },
        "&.crates": {
           ...tabularSectionCratesStyles(theme),
        },
        "& .itemDiv": {
          padding: theme.spacing(0),
          "& .content": {
            width: "100%",
            "& .itemsContainer": {
              flexWrap: "nowrap",
              "& .item": {
                padding: theme.spacing(2, 0),
                borderBottom: `1px solid ${theme.palette.secondary.dark}`,
                "&:first-child": {
                  padding: 0,
                },
                "&:last-child": {
                  borderBottom: "none",
                },
                "& .itemContainer": {
                  padding: theme.spacing(0, 2),
                  "&.items": {
                    backgroundColor: COLORS.SECONDARY_MAIN,
                    padding: theme.spacing(2),
                  },
                  "& p": {
                    fontSize: 14,
                    lineHeight: "17px",
                    fontWeight: 600,
                  },
                  "&.header p": {
                    color: COLORS.DOVE_GRAY,
                    fontWeight: 500,
                  },
                  "& .itemColumn": {
                    padding: theme.spacing(0),
                    "&.item1": {
                      "& p": {
                        fontWeight: 400,
                        textTransform: "capitalize",
                      },
                      "& .rejectedReason": {
                        fontSize: 10,
                        color: COLORS.ALIZARIN_CRIMSON,
                      },
                      "& .viewOriginalLink": {
                        fontSize: 9,
                        color: COLORS.COPY,
                        cursor: "pointer",
                        paddingRight: 6,
                      },
                      "& .originalName": {
                        fontSize: 14,
                        lineHeight: "17px",
                        fontWeight: 400,
                      },
                    },
                    "&.item2": {
                      "& p": {
                        textAlign: "center",
                        "& .green": {
                          color: COLORS.PERSIAN_GREEN,
                        },
                      },
                    },
                    "&.item3": {
                      "& p": {
                        textAlign: "right",
                      },
                    },
                  },
                  "& .itemRow": {
                    padding: theme.spacing(1),
                    "&.item1": {
                      "& p": {
                        fontWeight: 500,
                      },
                    },
                    "&.item2": {
                      "& p": {
                        fontWeight: 400,
                      },
                    },
                  },
                },
              },
            },
           ...paymentContainerStyles(theme),
          },
        },
      },
    },
    accordionSummary: {
      minHeight: "54px",
      marginTop: "8px",
      "& .header": {
        fontSize: 14,
        fontWeight: 600,
        paddingBottom: theme.spacing(0.5),
        margin: "auto 0px",
        "&:last-child": {
          paddingBottom: 0,
        },
        "& .smallHeading": {
          fontSize: 12,
        },
      },
      "& .content": {
        flexGrow: 1,
      },
    },
    checkbox: {
      marginLeft: "0px",
    },
    timeline: {
      ...timelineBaseStyles(),
      "& .timelineItem": {
        ...timelineItemStyles(),
        "& .timelineDot": {
          ...timelineDotStyles(),
        },
        "& .primaryConnector": {
          ...timelineConnectorStyles(),
        },
        "& .timelineContent": {
           ...timelineContentStyles(theme),
        },
        "& .lastModifiedContent": {
          fontSize: "12px",
          lineHeight: "10px",
          color: COLORS.DOVE_GRAY_DARK,
          paddingTop: "6px",
          "& .name": {
            marginLeft: "4px",
          },
        },
        "& .timelineContentItem": {
          padding: "8px 0px",
        },
      },
    },
    tabs: {
      paddingTop: "0px",
      paddingLeft: "0px",
      minHeight: "38px",
      "& .tabLabel": {
        fontSize: "14px",
        fontWeight: 700,
      },
    },
    dialogPaperPropsRoot: {
      margin: 0,
      marginLeft: "auto",
      maxHeight: "none",
      height: "100vh",
      width: 680,
    },
    confirmDialogPaperPropsRoot: {
      width: 338,
      height: 214,
      margin: "auto",
      borderRadius: theme.spacing(1),
    },
    confirmDialogContentContainer: {
      flexDirection: "column",
      flexWrap: "nowrap",
      "& .contentItem": {
        "& p": {
          lineHeight: 1.2,
        },
        "&.heading": {
          "& p": {
            fontSize: 24,
            fontWeight: 600,
          },
        },
        "&.desc": {
          padding: theme.spacing(0, 2.5),
          "& p": {
            fontSize: 18,
            fontWeight: 400,
            "& .count": {
              fontWeight: 600,
            },
          },
        },
      },
    },
    confirmDialogButtonsContainer: {
      justifyContent: "center",
      "& .dialogBtn": {
        "&.primary": {
          marginLeft: theme.spacing(1),
        },
      },
    },
    verticalDiv: {
      color: "#0E5AA7",
      height: "16px",
      background: "#0E5AA7",
      width: "2px",
      margin: "2px 16px 0px 16px",
    },
    ...useSideModalCloseOpenStyles(),
    executionStatus: {
      display: "flex",
      "& .tag": {
        fontSize: "10px",
        fontWeight: 600,
        borderRadius: "8px",
        background: "#FAFAFB",
        display: "flex",
        alignItems: "center",
        padding: "4px",
        "&.ORANGE": {
          color: COLORS.GOLDEN_BELL,
        },
        "&.SUCCESS_GREEN": {
          color: COLORS.PERSIAN_GREEN_DARK,
        },
      },
    },
    orderCommentsContainer: {
      flexDirection: "column",
      flexWrap: "nowrap",
      "& .comments": {
        padding: "20px",
        borderRadius: "4px",
        background: COLORS.WHITE,
        boxShadow: "0px 4px 48px rgba(0, 0, 0, 0.08)",
        backdropFilter: "blur(24px)",
        marginBottom: theme.spacing(2),
        display: "flex",
        flexDirection: "column",
        "& .item": {
          display: "flex",
          "&.second": {
            marginTop: theme.spacing(1),
          },
        },
        "& .title": {
          fontSize: "12px",
          fontWeight: 600,
          color: COLORS.MINE_SHAFT,
          "&.second": {
            whiteSpace: "nowrap",
          },
        },
        "& .content": {
          fontSize: "12px",
          fontWeight: 500,
          color: COLORS.DOVE_GRAY,
          "&.second": {
            marginLeft: theme.spacing(1),
          },
        },
      },
      "& .contentAreaItem": {
        paddingBottom: theme.spacing(3),
        flexGrow: 1,
        "& .itemContainer": {
          flexDirection: "column",
          "& .itemLabel": {
            paddingBottom: theme.spacing(1),
            alignSelf: "flex-start",
            "& p": {
              fontSize: 14,
              fontWeight: 400,
            },
          },
          "& .itemInput": {
            "& .MuiOutlinedInput-input": {
              fontSize: 14,
              fontWeight: 400,
            },
          },
        },
      },
    },
    buttons: {
      display: "flex",
      justifyContent: "flex-end",
      "& .userBtn": {
        "&.secondary": {
          marginRight: theme.spacing(2),
        },
        flexGrow: 1,
      },
    },
    accordianVerticalDiv: {
      color: "#0E5AA7",
      height: "16px",
      background: "#0E5AA7",
      width: "2px",
      margin: "auto 8px auto 8px",
    },
    titleContent: {
      fontSize: 12,
      fontWeight: 600,
      margin: "auto 0px",
      color: COLORS.PERSIAN_GREEN_DARK,
    },
    topLevelShieldCheckStyle: {
      margin: "auto 0px auto 8px",
      fill: COLORS.WHITE,
    },
    shieldCheckStyle: {
      margin: "auto 4px auto 0px",
      fill: COLORS.WHITE,
    },
    driverSectionHeadings: {
      margin: "16px 16px",
      "& .heading": {
        width: "100%",
        fontWeight: "bold",
        fontSize: "14px",
      },
    },
    driverItemsContainer: {
      marginTop: "8px",
      gap: "8px",
    },
    driverContainer: {
      "& .itemRow": {
        padding: theme.spacing(0),
        "&.item1": {
          "& p": {
            fontWeight: 400,
            fontSize: 14,
          },
        },
        "&.item2": {
          "& p": {
            fontWeight: 500,
            fontSize: 14,
          },
        },
      },
    },
  })
);
